document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.article-related-products');

  wrappers.forEach(wrapper => {
    const scroll = wrapper.querySelector('.arp-scroll');
    const slides = wrapper.querySelectorAll('.arp-slide');
    const prev = wrapper.querySelector('.arp-prev');
    const next = wrapper.querySelector('.arp-next');

    if (!scroll || slides.length === 0) return;

    let index = 0;

    const scrollToIndex = (i) => {
      const slide = slides[i];
      if (!slide) return;

      const scrollLeft =
        slide.offsetLeft - (scroll.clientWidth / 2) + (slide.clientWidth / 2);

      scroll.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    };

    next?.addEventListener('click', () => {
      index = Math.min(index + 1, slides.length - 1);
      scrollToIndex(index);
    });

    prev?.addEventListener('click', () => {
      index = Math.max(index - 1, 0);
      scrollToIndex(index);
    });
  });
});